// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__pxXR4","topBottomMargin":"container_topBottomMargin__LrPvX"};